import React from 'react';
import { CTAButton } from './ui/CTAButton';
import { ShieldCheckIcon, LockIcon, CreditCardIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="pt-28 pb-16 px-4 bg-white text-center" data-id="element-189">
      <div className="max-w-4xl mx-auto" data-id="element-190">
        <h1 className="text-3xl sm:text-4xl md:text-6xl lg:text-7xl font-black text-brand-dark mb-3 leading-tight tracking-tight" data-id="element-191">
          De Empleado a Dueño de tu Tiempo: <br className="hidden md:block" data-id="element-192" />
          Aprendé el Oficio que te da <br className="hidden md:block" data-id="element-193" />
          <span className="text-brand-amber underline decoration-brand-forge decoration-4 md:decoration-8 underline-offset-4 md:underline-offset-8" data-id="element-194">
            Libertad Financiera Real
          </span>
        </h1>

        <a href="#compra" className="block cursor-pointer md:transform md:hover:scale-[1.02] transition-transform duration-300 mb-8 mt-8" data-id="element-195">
          <picture data-id="element-196">
            <source srcSet="https://cdn.magicpatterns.com/uploads/6RNKumnwqYoEX1a1ns37fg/carpintero_hero_mobile_768.webp" media="(max-width: 768px)" data-id="element-197" />
            <img src="https://cdn.magicpatterns.com/uploads/6RNKumnwqYoEX1a1ns37fg/carpintero_hero_mobile_768.webp" alt="Manual del Maestro Carpintero del Acero — Mega Pack Completo" className="w-full max-w-3xl mx-auto drop-shadow-2xl" width={768} height={432} fetchPriority="high" loading="eager" decoding="async" data-id="element-198" />
          </picture>
        </a>

        <p className="text-base sm:text-lg md:text-xl text-gray-700 max-w-3xl mx-auto mb-10 leading-relaxed" data-id="element-199">
          El único sistema completo en Argentina que te enseña a fabricar
          muebles de acero que se venden solos — y a construir tu propio negocio
          desde las manos.
        </p>

        <div className="flex flex-wrap justify-center gap-4 mb-10" data-id="element-200">
          <span className="flex items-center gap-2 bg-gray-100 px-4 py-2 rounded-lg font-semibold text-gray-800" data-id="element-201">
            📄 100% PDF
          </span>
          <span className="flex items-center gap-2 bg-gray-100 px-4 py-2 rounded-lg font-semibold text-gray-800" data-id="element-202">
            ⚡ Acceso inmediato
          </span>
          <span className="flex items-center gap-2 bg-gray-100 px-4 py-2 rounded-lg font-semibold text-gray-800" data-id="element-203">
            🇦🇷 Hecho en Argentina
          </span>
        </div>

        <div className="max-w-2xl mx-auto mb-6" data-id="element-204">
          <CTAButton text="🔥 → QUIERO MI MANUAL AHORA" href="#compra" isLink={true} data-id="element-205" />
        </div>

        <div className="flex flex-wrap justify-center items-center gap-6 text-sm md:text-base text-gray-600 font-medium" data-id="element-206">
          <img src="https://cdn.magicpatterns.com/uploads/t7CM3MNeFeZ9cbVMfzE6en/jo3l6snt.png" alt="Garantía 7 días de reembolso" className="w-20 h-20" width={80} height={80} loading="eager" data-id="element-207" />
          <span className="flex items-center gap-1" data-id="element-208">
            <LockIcon className="w-5 h-5 text-gray-500" data-id="element-209" /> Pago 100% seguro vía
            Mercado Pago
          </span>
        </div>
      </div>
    </section>;
}